module.exports = __webpack_public_path__ + "static/media/JB-Regular.77c66657.woff";